import React from "react";

const SkeletonCard = ({
  type = "text", // "avatar", "text", "avatar-text", or "rectangle"
  lines = 3,
  heights = [],
  widths = [],
  avatarSize = 40, // default 40px
  rectangleWidth = "100%",
  rectangleHeight = 150,
  className = "",
}) => {
  const renderAvatar = () => (
    <div
      className="bg-gray-200 rounded-full shrink-0"
      style={{
        width: avatarSize,
        height: avatarSize,
      }}
    />
  );

  const renderTextLines = () => (
    <div className="flex-1 space-y-2">
      {Array.from({ length: lines }).map((_, idx) => (
        <div
          key={idx}
          className="bg-gray-200 rounded-full"
          style={{
            width: widths[idx] || "100%",
            height: heights[idx] || "16px",
          }}
        />
      ))}
    </div>
  );

  const renderRectangle = () => (
    <div
      className="bg-gray-200 rounded-lg"
      style={{ width: rectangleWidth, height: rectangleHeight }}
    />
  );

  return (
    <div
      role="status"
      className={`animate-pulse ${
        type !== "rectangle" ? "flex items-center gap-4" : ""
      } ${className}`}
    >
      {type === "avatar" && renderAvatar()}
      {type === "text" && renderTextLines()}
      {type === "avatar-text" && (
        <>
          {renderAvatar()}
          {renderTextLines()}
        </>
      )}
      {type === "rectangle" && renderRectangle()}
    </div>
  );
};

export default SkeletonCard;
